export default __webpack_public_path__ + "media/images/svg/dog-frisbee-icon-f035e8f5c061496104f84405f9de706f.svg";